// Language options
import {LanguageCode} from "../enum";

export const LANGUAGE_OPTIONS = [
    {code: LanguageCode.ZUL, name: 'isiZulu'},
    {code: LanguageCode.ENG, name: 'English'},
    {code: LanguageCode.AFR, name: 'Afrikaans'},
    {code: LanguageCode.XHO, name: 'isiXhosa'},
    {code: LanguageCode.NSO, name: 'Sepedi'},
    {code: LanguageCode.TSN, name: 'Setswana'},
    {code: LanguageCode.SOT, name: 'Sesotho'},
    {code: LanguageCode.VEN, name: 'Tshivenda'},
    {code: LanguageCode.TSO, name: 'Xitsonga'},
    {code: LanguageCode.SSW, name: 'siSwati'},
    {code: LanguageCode.NBL, name: 'isiNdebele'},
];